import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../common-components/button/Button.jsx";
import InputField from "../../common-components/input-field/Input-field.jsx";
import Select from "../../common-components/select/Select.jsx";
import { setSelectedSourceOption, updateSelectedSourceOption, sourceDatabase, setSourcePayload } from "../../state/reducers/databaseConversion.js";
import { dbOptions } from "./database-conversion-options";

function SourceOptionsDB() {
  const [sourceDB, setSourceDB] = useState();
  const [errors, setErrors] = useState();
  const selectedSourceOption = useSelector((state) => state.databaseConversion.selectedSourceOption);
  const dispatch = useDispatch();
  const sourceList = dbOptions.map(option => {
    return {
      label: option.dbName,
      value: option.dbName
    }
  });

  const handleSourceValueChange = (target, name, type) => {
    let value = target.value;
    if (name === "port") {
      value = parseInt(value, 10);
    }
    if (type === "file") {
      dispatch(updateSelectedSourceOption({
        value,
        file: target.files[0],
        name: name
      }));
    } else {
      dispatch(updateSelectedSourceOption({
        value,
        name: name
      }));
    }
  };

  useEffect(() => {
    if(sourceDB){
      const options = dbOptions.find(option => option.dbName === sourceDB).options;
      const sourceOption = options.map(option => {
        const updateOption = { ...option }
        updateOption.value = undefined
        return updateOption;
      })
      dispatch(setSelectedSourceOption(sourceOption))
    }
  }, [sourceDB])

  const handleNextClick = async () => {
    let fieldErrors = {};
    if (!selectedSourceOption || !sourceDB) {
      fieldErrors.sourceDB = "Select Source option"
      setErrors({
        ...errors,
        ...fieldErrors
      })
      console.error("Source options or database not selected");
      return;
    }
    selectedSourceOption.map(option => {
      console.log("Options: ", option)
      if(option.validations.required && !option.value){
        console.log("Condition Satisfied")
        fieldErrors[option.inputName] = option.labelName + " is required"
      } else {
        fieldErrors[option.inputName] = undefined
      }
    })
    setErrors({
      ...errors,
      ...fieldErrors
    })
    let errorFlag = false;
    // Loop through the object keys
    for (let key in fieldErrors) {
      // Check if the value of the key is not undefined
      if (fieldErrors[key] !== undefined) {
        errorFlag = true;  // If any value is not undefined, return false
      }
    }

    if(errorFlag){
      return;
    }
    const properties = selectedSourceOption.reduce((acc, option) => {
      acc[option.inputName] = option.value;
      return acc;
    }, {});
    console.log("properties", properties)
    
    const payload = {
      name: sourceDB,
      properties
    };
    console.log("sourcePayload", payload)

    dispatch(setSourcePayload({
      [`${sourceDB.toLowerCase()}_details`]: payload
    }));
    // dispatch(setCurrentStep(2));
    dispatch(sourceDatabase(properties));
  };
  console.log("Errors: ", errors)

  // Split the remaining options after the first two
  const firstRowOptions = selectedSourceOption?.slice(0, 2) || [];
  const remainingOptions = selectedSourceOption?.slice(2) || [];

  // Function to chunk remaining array into groups of 3
  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );
  };

  const remainingOptionsChunks = chunkArray(remainingOptions, 3);

  return (
    <div className="page-wrapper database-conversion-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">Connect to Source Database</h2>
              <div className="database-conversation-wrapper">
                <div className="source-wrapper">
                  <Row> 
                    <Col md="4">
                      <Select value={sourceDB} 
                        onChange={(e) =>{
                          if(e.target.value){
                            setErrors({
                              ...errors,
                              sourceDB: undefined
                            })
                          }
                          setSourceDB(e.target.value)
                        }} 
                        label="Source Database" 
                        options={sourceList} 
                        layoutStyle="vertical"
                        labelColSize={4}
                        inputColSize={8}
                        required={true}
                        validationMsg={errors?.sourceDB}
                      />
                    </Col>
                    {firstRowOptions.map((source) => (
                      <Col md="4" key={source.inputName}>
                        <InputField 
                          type={source.inputName === "port" ? "number" : source.inputType}
                          label={source.labelName}
                          value={source.value}
                          id={source.inputName}
                          onChange={(e) => handleSourceValueChange(e.target, source.inputName, source.inputType)}
                          layoutStyle="vertical"
                          labelColSize={4}
                          inputColSize={8}
                          required={source.validations.required}
                          validationMsg={source.validations.required ? errors?.[source.inputName] : undefined}
                        />
                      </Col>
                    ))}
                  </Row>
                  {remainingOptionsChunks.map((chunk, rowIndex) => (
                    <Row key={`row-${rowIndex}`}>
                      {chunk.map((source) => (
                        <Col md="4" key={source.inputName}>
                          <InputField 
                            type={source.inputName === "port" ? "number" : source.inputType}
                            label={source.labelName}
                            value={source.value}
                            id={source.inputName}
                            onChange={(e) => handleSourceValueChange(e.target, source.inputName, source.inputType)}
                            layoutStyle="vertical"
                            labelColSize={4}
                            inputColSize={8}
                            required={source.validations.required}
                            validationMsg={source.validations.required ? errors?.[source.inputName] : undefined}
                          />
                        </Col>
                      ))}
                    </Row>
                  ))}
                  {/* <Row>
                    {selectedSourceOption?.map((source) => (
                      <Col md="4" key={source.inputName} >
                        <InputField 
                          type={source.inputName === "port" ? "number" : source.inputType} 
                          label={source.labelName} 
                          value={source.value} 
                          id={source.inputName} 
                          onChange={(e) => handleSourceValueChange(e.target, source.inputName, source.inputType)}
                          layoutStyle="vertical"
                          labelColSize={4}
                          inputColSize={8}
                          required={source.validations.required}
                          validationMsg={source.validations.required ? errors?.[source.inputName] : undefined}
                        />
                      </Col>
                    ))}
                  </Row> */}  
                  <Row>
                    <Col className="text-end">
                      <CustomButton className="next-btn" label="Next" onClick={handleNextClick} />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SourceOptionsDB;
  